class ProductsDelegate {
    setIsOpen(isOpen) {
        this.setState({ isOpen });
    }

    setRows(rows) {
        this.setState({ rows });
    }

    setSelectedProduct(selectedProduct) {
        this.setState({ selectedProduct });
    }

    showEditDrawer(product) {
        this.setState({ selectedProduct: product, isOpen: true });
    }
}

export default ProductsDelegate;
